export default __webpack_public_path__ + "static/media/self.f52fdafb.svg";